import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static targets = ["editButton", "formContainer", "checkboxLabel", "checkbox"];

  connect() {
    // 初期状態でチェックボックスを隠す
    this.hideCheckboxes();
  }

  toggleEditing(event) {
    const button = $(event.currentTarget);
    const page = button.closest(".js-news");
    const link = page.find(".js-news-link");

    if (page.hasClass("is-editing")) {
      page.removeClass("is-editing");
      button.trigger("focus");
      link.attr("tabindex", "0");
      this.hideCheckboxes();
    } else {
      page.addClass("is-editing");
      $(".js-news-edit-button").trigger("focus");
      link.attr("tabindex", "-1");
      this.showCheckboxes();
    }
    document.activeElement.blur();
  }

  showCheckboxes() {
    this.checkboxLabelTargets.forEach((label) => {
      $(label).show();
    });
  }

  hideCheckboxes() {
    this.checkboxLabelTargets.forEach((label) => {
      $(label).hide();
    });
  }

  postSubmit() {
    $("form#all_read").attr("method", "post");
  }

  deleteSubmit() {
    $("form#all_read").attr("method", "delete");
  }
}
